var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.setClass && _vm.setClass.length ? _vm.setClass : 'form-group'},[_c('button',{staticClass:"active_duplicate duplicate_img",on:{"click":_vm.setValue}},[_c('img',{attrs:{"src":require("./icon/dublicate.png")}})]),_c('label',[_vm._v("Duplicate")])])
}
var staticRenderFns = []

export { render, staticRenderFns }